import { graphql } from '@mp/graphql/generated';
import { useGraphQLQuery } from '@mp/hooks/useGraphQLRequest';
import { type ResultOf } from '@graphql-typed-document-node/core';

const StatesGql = graphql(`
  query GetStatesForEducationForm($input: StateQueryInput) {
    states(input: $input) {
      id
      name
    }
  }
`);

const CurrentUserGql = graphql(`
  query GetCurrentUserForEducationForm {
    me {
      professional {
        id
      }
    }
  }
`);

const AssignmentRequestsGql = graphql(`
  query GetAssignmentRequestsForEducationForm($input: AssignmentRequestQueryInput) {
    assignmentRequests(input: $input) {
      id
    }
  }
`);

export const useStatesForEducationForm = () => {
  const { data, isLoading } = useGraphQLQuery<ResultOf<typeof StatesGql>>({
    operationName: 'GetStatesForEducationForm',
    queryKey: ['states'],
    query: StatesGql,
    variables: { input: { orderBy: { name: true } } },
  });

  const states = data?.states || [];

  return {
    isLoading,
    states,
  };
};

export const useAssignmentRequestsForEducationForm = (assignmentId?: number) => {
  const { data: currentUserData, isLoading: currentUserLoading } = useGraphQLQuery<
    ResultOf<typeof CurrentUserGql>
  >({
    operationName: 'GetCurrentUserForEducationForm',
    query: CurrentUserGql,
    variables: {},
  });
  const currentUser = currentUserData?.me;

  const professional_id = currentUser?.professional?.id;
  const enabled = assignmentId === undefined || !!assignmentId;

  const { data: assignmentRequestsData, isLoading: assignmentRequestsLoading } = useGraphQLQuery<
    ResultOf<typeof AssignmentRequestsGql>
  >({
    operationName: 'GetAssignmentRequestsForEducationForm',
    query: AssignmentRequestsGql,
    variables: {
      input: { filter: { assignment_id: assignmentId }, orderBy: { updated_at: false } },
      professional_id,
    },
    enabled,
  });
  const assignmentRequests = assignmentRequestsData?.assignmentRequests || [];

  const isLoading = currentUserLoading || assignmentRequestsLoading;

  return { assignmentRequests, isLoading };
};
